<template>
	<div id="pcapp">
		<div class="headArea  flexBtw mainArea wow fadeIn">
			<img class="logoImg" src="../assets/logo.png" />
			<img class="menuImg" src="../assets/menu.png" @click="menuShow=!menuShow" />
			<div id="nav" v-if="menuShow" @click="navClick">
				<router-link :to="(isMobile?'/mobile':'/pc')+'/home'">首页</router-link>
				<router-link :to="(isMobile?'/mobile':'/pc')+'/about'">关于我们</router-link>
				<router-link :to="(isMobile?'/mobile':'/pc')+'/business'">业务布局</router-link>
				<router-link :to="(isMobile?'/mobile':'/pc')+'/cinema'">VR影院</router-link>
				<router-link :to="(isMobile?'/mobile':'/pc')+'/team'">管理团队</router-link>
				<router-link :to="(isMobile?'/mobile':'/pc')+'/see'">橙猩视点</router-link>
				<router-link :to="(isMobile?'/mobile':'/pc')+'/contect'">联系我们</router-link>
			</div>
		</div>
		<div style="padding-top: 70px;">
			<router-view :key="key" />
		</div>
		<div class="footArea wow fadeIn">
			<div class="light-1"></div>
			<div class="top mainArea">
				<img class="logoImg2" src="../assets/logo.png" />
				<img class="footimg1" src="../assets/chart.png" style="width: 80px;" />
				<div class="footCenter">
					<p>021-59199956</p>
					<p>上海市徐汇区漕溪北路595号A座8013室</p>
					<div class="footNav flexBtw">
						<router-link :to="(isMobile?'/mobile':'/pc')+'/home'">首页</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/about'">关于我们</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/business'">业务布局</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/cinema'">VR影院</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/team'"></router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/see'">橙猩视点</router-link>
						<router-link :to="(isMobile?'/mobile':'/pc')+'/contect'">联系我们</router-link>
					</div>
				</div>
				<div>
					<img class="footimg2" src="../assets/chart.png" style="width: 80px;" />
				</div>
			</div>
			<div class="copyBox flexBtw mainArea">
				<a href="https://beian.miit.gov.cn/">沪ICP备2022023873号-1 Copyright @2022-2026 版权所有 上海橙猩数字娱乐科技有限公司</a><br><a
					href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010402010121">沪公网安备31010402010121号</a>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'App',
		data() {
			return {
				menuShow: true
			}
		},
		mounted() {
			if (window.innerWidth <= 800) {
				this.menuShow = false
			}
			this.$nextTick(() => {
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		},
		computed: {
			isMobile() {
				return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			},
			key() {
				return this.$route.path
			}
		},
		methods: {
			navClick() {
				if (window.innerWidth <= 800 || this.isMobile) {
					this.menuShow = !this.menuShow
				}
			},
		},

	}
</script>
<style lang="less" scoped>
	.flexBtw {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	#pcapp {
		background: #000;
	}

	.headArea {
		position: absolute;
		top: 20px;
		z-index: 999999;

		.logoImg {
			height: 40px;
			width: auto;
		}

		.menuImg {
			display: none;
			height: 30px;
		}
	}

	.footArea {
		position: relative;
		overflow: hidden;
		padding-top: 50px;
		padding-bottom: 50px;
		background: #000;
		font-size: 12px;

		.footimg1 {
			display: none;
		}

		.copyBox {
			color: #ddd;
		}

		.light-1 {
			position: absolute;
			width: 1000px;
			height: 1000px;
			border-radius: 50%;
			filter: blur(80px);
			animation: moveAround 10s linear infinite;
			background: rgba(106, 0, 255, 0.4);
			top: -900px;
			left: calc(50% - 500px);
			animation-delay: 0s;
		}

		.top {
			border-bottom: 1px solid #ddd;
			padding-bottom: 50px;
			margin-bottom: 50px;
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.footCenter {
			text-align: left;
			width: 40%;
			line-height: 30px;

			.footNav {
				margin-top: 30px;
				padding-top: 30px;
				border-top: 1px solid #ddd;
			}
		}

		.logoImg2 {
			height: 50px;
			width: auto;
		}
	}

	.mainArea {
		width: calc(100% - 300px);
		margin-left: 140px;
		margin-right: 140px;
	}

	html {
		scroll-behavior: smooth;
	}

	body * {

		box-sizing: border-box;
		flex-shrink: 0;
		color: #fff;
	}

	* {
		margin: 0;
		padding: 0;
	}

	img {
		vertical-align: top;
		border: 0;
	}

	li {
		list-style: none;
	}

	a {
		color: inherit;
		text-decoration: none;
	}

	a[href] {
		cursor: pointer;
	}

	a:hover {
		text-decoration: none;
		cursor: pointer;
	}

	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		position: relative;

	}

	.pcBox {
		background: #000;
		color: #2c3e50;
	}

	#nav {
		color: #fff;
		font-size: 14px;
		width: calc(100% - 350px);
		text-align: right;

		a {
			font-weight: bold;
			color: #fff;
			margin-left: 40px;

			&.router-link-exact-active {
				color: #ff791f;
			}
		}
	}

	@media (max-width:1440px) {
		.mainArea {
			width: calc(100% - 100px);
			margin-left: 40px;
			margin-right: 40px;
		}
		#nav {		
			a {
				margin-left: 20px;				
			}
		}
	}

	@media (max-width:800px) {

		.mainArea {
			width: calc(100% - 20px);
			margin-left: 10px;
			margin-right: 10px;
		}

		.menuImg {
			display: block !important;
		}

		#nav {
			position: absolute;
			right: 0px;
			background: #fff;
			top: 60px;
			padding-top: 10px;
			padding-bottom: 10px;
			text-align: center;
			width: 90px;

			a {
				display: block;
				color: #999;
				margin-left: 0px;
				line-height: 30px;

				&.router-link-exact-active {
					color: #ff791f;
				}
			}
		}

		.headArea {
			position: fixed;
			padding-top: 20px;
			padding-bottom: 20px;
			background: #000;
			width: 100vw !important;
			padding-left: 10px;
			padding-right: 10px;
			left: -10px;
			top: 0;

			.logoImg {
				height: 30px;
			}
		}

		.footArea {
			padding-top: 20px;
			padding-bottom: 20px;

			.footimg1 {
				display: block;
			}

			.footimg1 {
				display: none;
			}

			.top {
				padding-bottom: 20px;
				margin-bottom: 20px;
				display: block;

				.logoImg2 {
					display: none;
				}
			}

			.footCenter {
				width: 100%;
				margin-top: 30px;
				text-align: center;
				line-height: 30px;

				.footNav {
					margin-top: 10px;
					padding-top: 10px;
				}
			}
		}
	}
</style>